import { convertEditorJSONToHTML } from './editorConversions';

const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

export const normalizeTemplateContentToHtml = (templateContent?: string): string => {
    const rawContent = (templateContent || '').trim();
    if (!rawContent) {
        return '<p style="margin:0;">Sin contenido definido.</p>';
    }

    if ((rawContent.startsWith('{') || rawContent.startsWith('['))) {
        try {
            const parsed = JSON.parse(rawContent);
            if (parsed && typeof parsed === 'object' && Array.isArray((parsed as any).blocks)) {
                const parsedHtml = convertEditorJSONToHTML(parsed as any);
                if (parsedHtml?.trim()) {
                    return parsedHtml;
                }
            }
        } catch (_) {
            // noop
        }
    }

    const bodyMatch = rawContent.match(/<body[^>]*>([\s\S]*)<\/body>/i);
    if (bodyMatch?.[1]) {
        return bodyMatch[1].trim();
    }

    return rawContent;
};

export const buildBrandedEmailPreviewTemplate = (subject: string, templateContent?: string): string => {
    const normalizedContent = normalizeTemplateContentToHtml(templateContent);
    const plainTextContent = normalizedContent
        .replace(/<style[\s\S]*?<\/style>/gi, ' ')
        .replace(/<script[\s\S]*?<\/script>/gi, ' ')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    const preheader = plainTextContent.slice(0, 140) || 'Nueva comunicación automática de Attiva.';
    const safeSubject = escapeHtml(subject || 'Comunicación Attiva');
    const safePreheader = escapeHtml(preheader);
    const currentYear = new Date().getFullYear();

    return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8" />
  <meta http-equiv="x-ua-compatible" content="ie=edge" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <title>${safeSubject}</title>
  <style>
    @media (max-width: 600px) {
      .container { width: 100% !important; }
      .px { padding-left: 16px !important; padding-right: 16px !important; }
      .h1 { font-size: 22px !important; line-height: 28px !important; }
    }
  </style>
</head>
<body style="margin:0; padding:0; background-color:#f6f9fc;">
<div style="display:none; max-height:0; overflow:hidden; opacity:0;">${safePreheader}</div>

<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#f6f9fc;">
  <tr>
    <td align="center">
      <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="600" class="container" style="width:600px; max-width:600px; margin:24px auto; background-color:#ffffff; border-radius:14px; overflow:hidden; box-shadow:0 4px 24px rgba(12,62,102,0.12);">
        <tr>
          <td align="center" style="background:#246AAAFF; padding:24px;">
            <img src="/assets/images/attiva-logo.png"
                 alt="Attiva"
                 width="120"
                 style="display:block; height:auto; border:0; outline:none; text-decoration:none; margin:0 auto 8px;" />
            <div style="color:#ffffff; font-family:Segoe UI, Helvetica, Arial, sans-serif; font-size:12px; letter-spacing:.08em; opacity:.9;">
              Comunicación Attiva
            </div>
          </td>
        </tr>

        <tr>
          <td class="px" style="padding:32px 32px 12px 32px; font-family:Segoe UI, Helvetica, Arial, sans-serif; color:#0c3e66;">
            <h1 class="h1" style="margin:0 0 12px; font-size:24px; line-height:32px; font-weight:700;">${safeSubject}</h1>
          </td>
        </tr>

        <tr>
          <td class="px" style="padding:0 32px 24px; font-family:Segoe UI, Helvetica, Arial, sans-serif; color:#23415e; font-size:14px; line-height:22px;">
            ${normalizedContent}
          </td>
        </tr>

        <tr>
          <td align="center" style="background:#246AAAFF; padding:18px;">
            <p style="margin:0; font-family:Segoe UI, Helvetica, Arial, sans-serif; color:#ffffff; font-size:12px; opacity:.9;">
              © ${currentYear} Attiva — Todos los derechos reservados
            </p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</body>
</html>`;
};
